import PButton from '@/components/pc/base/button'

export default {
  PButton
}

